<template>
  <div class="navbar-bookmarks flex items-center">
    <!-- STARRED PAGES - FIRST 10 -->
    <ul class="vx-navbar__starred-pages">
      <draggable v-model="starredPagesLimited" :group="{name: 'pinList'}" class="flex cursor-move">
        <li class="starred-page" v-for="page in starredPagesLimited" :key="page.url">
          <vx-tooltip :text="page.title" position="bottom" delay=".3s">
            <feather-icon :svgClasses="['h-6 w-6 stroke-current', textColor]" class="p-2 cursor-pointer" :icon="page.icon" @click="$router.push(page.url).catch(() => {})" />
          </vx-tooltip>
        </li>
      </draggable>
    </ul>

    <!-- STARRED PAGES MORE -->
    <div class="vx-navbar__starred-pages--more-dropdown" v-if="starredPagesMore.length">
      <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" class="cursor-pointer p-2"></feather-icon>
        <vs-dropdown-menu>
          <ul class="vx-navbar__starred-pages-more--list">
            <draggable v-model="starredPagesMore" :group="{name: 'pinList'}" class="cursor-move">
              <li class="starred-page--more flex items-center cursor-pointer" v-for="page in starredPagesMore" :key="page.url" @click="$router.push(page.url).catch(() => {})">
                <feather-icon class="ml-2 mr-1" :icon="page.icon" :svgClasses="['h-5 w-5 stroke-current', textColor]"></feather-icon>
                <span class="px-2 pt-2 pb-1">{{ page.title }}</span>
              </li>
            </draggable>
          </ul>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>

    <div class="bookmark-container p-2" id="available-documents">
      <span class="mr-4 font-w-600">{{ planName }}</span>

      <button v-if="planName === 'Plan Profesional' || planName === 'Plan Demo'" @click="goTo('buy-plans')" class="text-white bg-secondary border-none cursor-pointer px-2 py-1 mr-2 rounded">{{ freeSubscriptionCredits.toLocaleString('en-US') }}</button>

      <span v-if="planName === 'Plan Profesional' || planName === 'Plan Demo'" @click="goTo('buy-credit-documents')" class="cursor-pointer">Firmas del Plan</span>

      <vx-tooltip
        class="inline-flex items-center"
        v-if="expirationTooltipText && (planName === 'Plan Profesional' || planName === 'Plan Flexible')"
        :text="expirationTooltipText"
        position="bottom"
        delay=".3s"
      >
        <div class="inline-flex items-center cursor-pointer" @click="goTo('buy-credit-documents')">
          <button class="text-white bg-primary border-none cursor-pointer px-2 py-1 mr-2 ml-2 rounded">{{ freeCreditsFromCreditPacks.toLocaleString('en-US') }}</button>
          <span>Firmas adicionales</span>
        </div>
      </vx-tooltip>

      <template v-else-if="planName === 'Plan Profesional' || planName === 'Plan Flexible'">
        <button @click="goTo('buy-credit-documents')" class="text-white bg-primary border-none cursor-pointer px-2 py-1 mr-2 ml-2 rounded">{{ freeCreditsFromCreditPacks.toLocaleString('en-US') }}</button>
        <span @click="goTo('buy-credit-documents')" class="cursor-pointer">Firmas adicionales</span>
      </template>
    </div>

  </div>
</template>

<script>
import draggable     from 'vuedraggable'
import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue'
import router from "../../../../router";
import moment from 'moment'

export default {
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  components: {
    draggable,
    VxAutoSuggest
  },
  data() {
    return {
      showBookmarkPagesDropdown : false,
    }
  },
  watch: {
    '$route'() {
      if (this.showBookmarkPagesDropdown) this.showBookmarkPagesDropdown = false
    }
  },
  computed: {
    freeCreditsFromCreditPacks() {
      return this.$store.state.account.user.me.free_credits_from_credits_packs;
    },
    freeSubscriptionCredits() {
      return this.$store.state.account.user.me.subscription_credits;
    },
    planName() {
      return this.$store.state.account.user.me.plan.name
    },
    nextCreditPackExpiration() {
      return this.$store.state.account.user.me.next_credit_pack_expiration;
    },
    formattedNextExpiration() {
      return this.nextCreditPackExpiration
        ? moment(this.nextCreditPackExpiration).format('DD/MM/YYYY')
        : null;
    },
    expirationTooltipText() {
      return this.formattedNextExpiration
        ? `Próx. vencimiento: ${this.formattedNextExpiration}`
        : null;
    },
    navbarSearchAndPinList() {
      return {pages: this.$store.state.navbarSearchAndPinList["pages"]}
    },
    starredPages() {
      return this.$store.state.starredPages
    },
    starredPagesLimited: {
      get() {
        return this.starredPages.slice(0, 10)
      },
      set(list) {
        this.$store.dispatch('arrangeStarredPagesLimited', list)
      }
    },
    starredPagesMore: {
      get() {
        return this.starredPages.slice(10)
      },
      set(list) {
        this.$store.dispatch('arrangeStarredPagesMore', list)
      }
    },
    textColor() {
      return {'text-white': this.$store.state.mainLayoutType === 'vertical' && this.navbarColor != (this.$store.state.theme === 'dark' ? "#10163a" : "#fff") }
    }
  },
  methods: {
    goTo(routeName) {
      router.push({name: routeName})
    },
    selected(obj) {
      this.$store.commit('TOGGLE_CONTENT_OVERLAY', false)
      this.showBookmarkPagesDropdown = false
      this.$router.push(obj.pages.url).catch(() => {})
    },
    actionClicked(item) {
      this.$store.dispatch('updateStarredPage', { url: item.url, val: !item.is_bookmarked })
      // this.$refs.bookmarkAutoSuggest.filterData()
    },
    outside: function() {
      this.showBookmarkPagesDropdown = false
    },
    hnd_search_query_update(query) {
      // Show overlay if any character is entered
      this.$store.commit('TOGGLE_CONTENT_OVERLAY', query ? true : false)
    }
  },
  directives: {
    'click-outside': {
      bind: function(el, binding) {
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler
        document.addEventListener('click', handler)
      },

      unbind: function(el) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null

      }
    }
  }
}

</script>
